export default "__VITE_ASSET__Djm8FfYo__"